import { axios } from "@Root/API";

export const putStudiesStudyProgrammeNote = (note_id, student_course_session_id, note_text) => {
  return axios.post(`attache/note/${note_id}/student-course-session`, { student_course_session_id, note_text, _method: "put" });
};
